// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".orders-table-vue[data-v-b6784d28]{min-height:300px}", ""]);
// Exports
module.exports = exports;
